
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./FixedReport.module.css";
import plus from "../../../Assets/plus.svg"
import ReportBackground from "../../../Assets/report.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import ExcelLogo from "../../../Assets/excel.png"
import PdfLogo from "../../../Assets/pdf.png"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer } from "lucide-react";
import { Spinner, Badge, Button, Modal, Form, Tab, Tabs } from 'react-bootstrap';
// import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, BASE_URL1, TOKEN } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import * as XLSX from 'xlsx'; // Import xlsx library
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Swal from 'sweetalert2';






const FixedAssetReport = () => {
  const [selectedFiles1, setSelectedFiles1] = useState(null);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [user, setUser] = useState('');
  const [userTyp, setUserTyp] = useState('');
  const [userTypes, setUserTypes] = useState('');
  console.log(userTypes, 'adminlevel');
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const navigate = useNavigate();
  const [selectedAssetId, setSelectedAssetId] = useState('');
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [provLoading, setProvLoading] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [processLoading, setProcessLoading] = useState(false);
  const [assetLoading, setAssetLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [loaddd, setLoaddd] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableDatas, setTableDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [eyeClicked, setEyeClicked] = useState(false);
const [trashClicked, setTrashClicked] = useState(false);
const [show1, setShow1] = useState(false);
const [selectedContinent, setSelectedContinent] = useState('');
const [selectedProvince, setSelectedProvince] = useState('');
const [selectedRegion, setSelectedRegion] = useState('');
const [selectedZone, setSelectedZone] = useState('');
const [selectedArea, setSelectedArea] = useState('');
const [selectedParish, setSelectedParish] = useState('');
const [show2, setShow2] = useState(false);
const [showComment, setShowComment] = useState(false);
const [areaLoad, setAreaLoad] = useState(false);
const [entriesPerPage, setEntriesPerPage] = useState(100);
const [currentPage, setCurrentPage] = useState();
const [currentPages, setCurrentPages] = useState();
const [searchTerm, setSearchTerm] = useState("");
const [tableData1, setTableData1] = useState([]);
const [tableData2, setTableData2] = useState([]);
const [tableData3, setTableData3] = useState([]);
const [tableData4, setTableData4] = useState([]);
const [tableData5, setTableData5] = useState([]);
const [tableData6, setTableData6] = useState([]);
const [tableData7, setTableData7] = useState([]);
const [areas, setAreas] = useState([]);
const [parishes, setParishes] = useState([]);
const [selectOptions, setSelectOptions] = useState([]);
const [tableData45, setTableData45] = useState([]);
const [tableData9, setTableData9] = useState([]);
const [zones, setZones] = useState([]);
const [selectedRows, setSelectedRows] = useState([]);
const [selectedItemId, setSelectedItemId] = useState(null);
const [continentID, setContinentID] = useState(null);
const [regionID, setRegionID] = useState(null);
const [provinceID, setProvinceID] = useState(null);

const [totalEntries, setTotalEntries] = useState("");
const [totalEntriess, setTotalEntriess] = useState("");
const [allReport,setAllReport] = useState(true);
const [totalPages, setTotalPages] = useState(1);
const [totalPagess, setTotalPagess] = useState(1);

const [comment, setComment] = useState('');

const [responseData, setResponseData] = useState([]);
const handleClose1 = () => {
  setShow1(false);
 
};
const handleClose2 = () => {
  setShow2(false);
 
};

const handleFileChange1 = (event) => {
  const files = event.target.files;
  setSelectedFiles1(Array.from(files));
};

const handleShow1 = (id) => {
  setSelectedAssetId(id);
  setShow1(true);
};

const handleShow2 = (id) => {
  setSelectedAssetId(id);
  setShow2(true);
};

const handleContinentChange = async (event) => {
  setSelectedContinent(event.target.value);
 setSelectedRegion("");
 setSelectedProvince("");
 setSelectedZone("");
 setSelectedArea("");
 setSelectedParish("");
}
const handleRegionChange = (event) => {
  setSelectedRegion(event.target.value);
 setSelectedProvince("");

}
const handleProvinceChange = (event) => {
  setSelectedProvince(event.target.value);
 setSelectedZone("");
}
// const handleZoneChange = (event) =>{
//   setSelectedZone(event.target.value);
//  setSelectedArea("");
  
// }
const handleParishChange = (event) =>{
  setSelectedParish(event.target.value);
  
}
const handleAreaChange = (event) =>{
  setSelectedArea(event.target.value);
 setSelectedParish("");
}


const readData = async () => {
  try {
    const value = localStorage.getItem('userToken');
    const value1 = localStorage.getItem('tobi');
    const admins = localStorage.getItem('admin');
    const userTypessss = localStorage.getItem('userType');
    const continentName = localStorage.getItem('continent');
    const regionName = localStorage.getItem('region');
    const provinceName = localStorage.getItem('province');

    if (value !== null) {
      setBearer(value);
    }
    if (value1 !== null) {
      setUser(value1);
    }
    if (admins !== null) {
      setUserTypes(admins);
  }
  if (continentName !== null) {
    setContinent(continentName);
}
if (regionName !== null) {
    setRegion(regionName);
}
if (provinceName !== null) {
    setProvince(provinceName);
    console.log(provinceName);
}
if (userTypessss !== null) {
  setUserTyp(userTypessss);
}
console.log(userTypessss);

  } catch (e) {
    alert('Failed to fetch the input from storage');
  }
};    

useEffect(() => {
  readData();
}, []);

const headers = {
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${bearer}`
};

const readData1 = async () => {
  try {
    const value4 = localStorage.getItem('provinceID');
    const value5 = localStorage.getItem('regionID');
    const value6 = localStorage.getItem('continentID');

   
    if (value4 !== null) {
      setProvinceID(value4);
    }
    if (value5 !== null) {
      setRegionID(value5);
    }
    if (value6 !== null) {
      setContinentID(value6);
    }
  } catch (e) {
    alert('Failed to fetch the input from storage');
  }
};

useEffect(() => {
  if (bearer)
  readData1();
}, [bearer]);

// const filteredData = tableData.filter(item => item.description.toLowerCase().includes(searchTerm.toLowerCase()));

// const totalPages = Math.ceil(filteredData.length / entriesPerPage);

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};


const handlePrevPages = () => {
  setCurrentPages(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPages = () => {
  setCurrentPages(prevPage => Math.min(prevPage + 1, totalPagess));
};


const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};

// const handlePrevPage = () => {
//   if (currentPage > totalPages) {
//     fetchProvinces(currentPage - 1);
//   }
// const handleNextPage = () => {
//   if (currentPage > totalPages) {
//     fetchProvinces(currentPage + 1);
//   }

// const totalEntries = filteredData.length;
const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
// const displayedData = filteredData.slice(startIndexx - 1, endIndexx);

//FIlterdata for Pending asset
const startPage = (currentPages - 1) * entriesPerPage + 1;
const endPage = Math.min(startIndexx + entriesPerPage - 1, totalEntriess);

    const fetchProvinces = async () => {
      setAssetLoading(true);
      try {
        console.log(userTyp);
        console.log(province);
        const params = { page: currentPage };
        if (userTypes == "Provincial Accountant") {
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-assets-by-province-name?province_id=${province}`, {
            params: params,
              headers: {
                  'Authorization': `Bearer ${TOKEN}`,
                  'Content-Type': 'application/json'
              }
          });
          const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntries(resultx);
          setTableData(results);
          setCurrentPage(resultxxx);
         
          const total = response.data?.data?.last_page || 1;
          setTotalPages(total);
          // Handle response for Provincial Accountant
      } else if (userTypes == "Regional Accountant") {
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-assets-by-province-name?region_id=${region}`, {
            params: params,
              headers: {
                  'Authorization': `Bearer ${TOKEN}`,
                  'Content-Type': 'application/json'
              }
          });
          // Handle response for National Accountant
          const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntries(resultx);
          setTableData(results);
          setCurrentPage(resultxxx);
          console.log(results);
          const total = response.data?.data?.last_page || 1;
          setTotalPages(total);
        } else if (userTypes == "Continental Accountant") {
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-assets-by-province-name?continent_id=${continent}`, {
            params: params,
              headers: {
                  'Authorization': `Bearer ${TOKEN}`,
                  'Content-Type': 'application/json'
              }
          });
          const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntries(resultx);
          setTableData(results);
          setCurrentPage(resultxxx);
          console.log(results);
          const total = response.data?.data?.last_page || 1;
          setTotalPages(total);
      } else {
          // Handle unauthorized or unknown user type
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-assets-by-province-name`, {
            params: params,
            headers: {
                'Authorization': `Bearer ${TOKEN}`,
                'Content-Type': 'application/json'
            }
        });
        const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntries(resultx);
          setTableData(results);
          setCurrentPage(resultxxx);
          console.log(results);
          const total = response.data?.data?.last_page || 1;
          setTotalPages(total);
          // console.log(resultxxx, 'current page');
          // console.log(resultx, 'total');
          // console.log(results, "Full Api Reponse");
          // console.log(total, "currentpage");

      }
      }       
      
      catch (error) {
        if (error.response && error.response.status === 401) {
          
          // navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
          setTableData([]);
        }
      } finally {
        setAssetLoading(false);
      }
    };
  
  
  
    useEffect(() => {
      if (TOKEN) {
        fetchProvinces();
      
      }
    }, [TOKEN, currentPage]);

   

    const FetchPending = async () => {
      setAssetLoading(true);
      try {
        console.log(userTyp);
        console.log(province);
        const params = { page: currentPages };
        if (userTypes == "Provincial Accountant") {
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-pending-assets-by-name?province_id=${province}`, {
            params: params,
              headers: {
                  'Authorization': `Bearer ${TOKEN}`,
                  'Content-Type': 'application/json'
              }
          });
          const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntriess(resultx);
          setTableDatas(results);
          setCurrentPages(resultxxx);
         
          const total = response.data?.data?.last_page || 1;
          setTotalPagess(total);
          // Handle response for Provincial Accountant
      } else if (userTypes == "Regional Accountant") {
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-pending-assets-by-name?region_id=${region}`, {
            params: params,
              headers: {
                  'Authorization': `Bearer ${TOKEN}`,
                  'Content-Type': 'application/json'
              }
          });
          // Handle response for National Accountant
          const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntriess(resultx);
          setTableDatas(results);
          setCurrentPages(resultxxx);
          console.log(results);
          const total = response.data?.data?.last_page || 1;
          setTotalPagess(total);
        } else if (userTypes == "Continental Accountant") {
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-pending-assets-by-name?continent_id=${continent}`, {
            params: params,
              headers: {
                  'Authorization': `Bearer ${TOKEN}`,
                  'Content-Type': 'application/json'
              }
          });
          const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntriess(resultx);
          setTableDatas(results);
          setCurrentPages(resultxxx);
          console.log(results);
          const total = response.data?.data?.last_page || 1;
          setTotalPagess(total);
      } else {
          // Handle unauthorized or unknown user type
          const response = await axios.get(`${BASE_URL1}/fixedassets/get-pending-assets-by-name`, {
            params: params,
            headers: {
                'Authorization': `Bearer ${TOKEN}`,
                'Content-Type': 'application/json'
            }
        });
        const results = response.data?.data?.data;
          const resultx = response.data?.data?.total;
          const resultxxx = response.data?.data?.current_page;
          setTotalEntriess(resultx);
          setTableDatas(results);
          setCurrentPages(resultxxx);
          console.log(results);
          const total = response.data?.data?.last_page || 1;
          setTotalPagess(total);
          // console.log(resultxxx, 'current page');
          // console.log(resultx, 'total');
          // console.log(results, "Full Api Reponse");
          // console.log(total, "currentpage");

      }
      }       
      
      catch (error) {
        if (error.response && error.response.status === 401) {
          
          // navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
          setTableData([]);
        }
      } finally {
        setAssetLoading(false);
      }
    };

    useEffect(() => {
      if (TOKEN) {
        FetchPending();
      
      }
    }, [TOKEN, currentPages]);


    const handleViewFixed = async (id) => {
      setSelectedItemId(id);
          setViewLoading(true);
          console.log(id)
          try {
            const response = await axios.get(`${BASE_URL1}/fixedassets/get-by-type?parish_id=${id}`,
              
              {headers:{
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${TOKEN}`
          }});
  
            const instructionData1 = response.data?.data?.assets?.data;
            setResponseData(instructionData1);
            const resultx = response.data?.data?.assets?.total;
            setTotalEntries(resultx);
            const total = response.data?.data?.assets?.last_page || 1;
            setTotalPages(total);
           console.log(instructionData1, "Am here")

            navigate('/fixed_assets_register', {state: {parishID: id}});
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
  
          } finally {
            setViewLoading(false);
          }
        }

        const handleEyeClicks = (id) => {
          const foundAsset = tableData.find(item => item.id === id);
          navigate('/view_asset_report', { state: { selectedAsset: foundAsset } });
          setEyeClicked(true);
        };

        const handleApprove = async (id) => {
          setSelectedItemId(id);
          setViewLoading(true);

          try {
            const formData = new FormData();
      
            formData.append("id", selectedItemId);
            formData.append("name", user);

            const headers = {
              "Content-Type": "multipart/form-data",
             'Authorization': `Bearer ${TOKEN}`
            };
      
            const response = await axios.post(
              `${BASE_URL1}/fixedassets/approve-fixed-asset`,
              formData,
              { headers }
            );
        
            // Show success message
            Swal.fire({
              title: 'Success',
              text: 'Approval was successful!',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              window.location.reload();
            });
        
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
              }
            }
            console.error('Approval error:', errorMessage);
          } finally {
            setViewLoading(false);
          }
        };

        const fetchDisapprove = async (id) => {
          setSelectedItemId(id);
          setViewLoading(true);
          setShowComment(true);

          try {
            const formData = new FormData();
      
            formData.append("id", selectedItemId);
            formData.append("name", user);
            formData.append("comment", comment);

            const headers = {
              "Content-Type": "multipart/form-data",
             'Authorization': `Bearer ${TOKEN}`
            };
      
            const response = await axios.post(
              `${BASE_URL1}/fixedassets/disapprove-fixed-asset`,
              formData,
              { headers }
            );
        
            // Show success message
            Swal.fire({
              title: 'Success',
              text: 'Disapproval was successful!',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              window.location.reload();
            });
        
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
              }
            }
            console.error('Approval error:', errorMessage);
          } finally {
            setViewLoading(false);
          }
        };

        const handleCancel = () => {

          setShowComment(true);
        };
      
        const handleDisapprove = () => {
          // handleSubmitComment(comment);
          fetchDisapprove();
          setShowComment(false);
          setViewLoading(true);
        };

     

        const handleProcess = async () => {
          setProcessLoading(true);
        
          try {
            const response = await axios.get(`${BASE_URL1}/fixedassets/all-approved-parish-assets?page=${currentPage}`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${TOKEN}`
              },
              params: {
                zone_id: selectedZone || '',
                area_id: selectedArea || '',
                parish_id: selectedParish || ''
              }
            });
        
            const results = response.data?.data?.data;
        setTableData(results);
        const resultx = response.data?.data?.data?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.data?.last_page || 1;
      setTotalPages(total);
        
            Swal.fire({
              icon: 'success',
              title: 'Successful',
              text: response.data.message,
            });
            setAllReport(false)
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data) {
              if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
              }
            }
        
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: errorMessage,
            });
          } finally {
            setProcessLoading(false);
          }
        };
        
      


const handleEyeClick = (id) => {
  const foundAsset = tableData.find(item => item.id === id);
  navigate('/edit_fixed_assets_register', { state: { selectedAsset: foundAsset } });
  setEyeClicked(true);
};

        const uploadDocument = async () => {
          setLoad(true);
        
          try {
            const formData = new FormData();
           
            formData.append('asset_id', selectedAssetId);
            selectedFiles1.forEach((file, index) => {
              formData.append(`asset_document[${index}]`, file);
            });
           
        
            const response = await axios.post(
              `${BASE_URL}/fixedassets/upload_document`,
              formData,
              {
                headers: {
                  ...headers,
                  'Content-Type': 'multipart/form-data',
                },
              }
            );
        
            console.log(response.data.message);
            handleClose1();
           
            setSelectedFiles1([]);
          //   fetchAssets();
      
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: response.data.message,
            });
        
            console.log(response.data);
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            console.log(error);
          } finally {
            setLoad(false);
          }
        };

        const fetchContinents = async () => {
          setIsLoading(true);
          try {
            const response = await axios.get(`${BASE_URL}/continents`, { headers });
      
            // console.log(response);
            const resultsss = response.data?.data;
            setTableData1(resultsss);
            // console.log(results);
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setTableData1([]);
          } finally {
            setIsLoading(false);
          }
        };
        useEffect(() => {
          if (bearer) {
        
            fetchContinents();
          }
        }, [bearer]);

        const fetchSubContinents = async (selectedContinent) => {
          setIsLoading(true);
          try {
            const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${selectedContinent}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearer}`,
          }, });
      
            // console.log(response);
            const subCont = response.data?.data;
            setTableData4(subCont);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setTableData4([]);
          } finally {
            setIsLoading(false);
          }
        };
      
        
      
        const fetchSubRegions = async (selectedRegion) => {
          setIsLoading(true);
          try {
            const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearer}`,
          }, });
      
            // console.log(response);
            const subReg = response.data?.data;
            setTableData5(subReg);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setTableData5([]);
          } finally {
            setIsLoading(false);
          }
        };
      
        
        const fetchSubProvinces = async (selectedProvince) => {
          setIsLoading(true);
          try {
            const response = await axios.get(`${BASE_URL}/provinces/getzonesprovince?province_id=${selectedProvince}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearer}`,
          }, });
      
            // console.log(response);
            const subReg = response.data?.data;
            setTableData6(subReg);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setTableData6([]);
          } finally {
            setIsLoading(false);
          }
        };

        const fetchAllZones = async (provinceID) => {
          setProvLoading(true);
          try {
            const response = await axios.get(`${BASE_URL1}/provinces/getzonesprovince?province_id=${provinceID}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${TOKEN}`,
          }, });
      
            // console.log(response);
            const subReg = response.data?.data;
            const options = subReg.map((item) => ({
              label: item.description,
              value: item.id,
            }));
            setZones(options);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setZones([]);
          } finally {
            setProvLoading(false);
          }
        };

        const fetchAllParishes = async (selectedArea) => {
          setProvLoading(true);
          try {
            const response = await axios.get(`${BASE_URL1}/areas/getparishesarea?area_id=${selectedArea}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${TOKEN}`,
          }, });
      
            // console.log(response);
            const subReg2 = response.data?.data;
            const options2 = subReg2.map((item) => ({
              label: item.description,
              value: item.id,
            }));
            setParishes(options2);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setParishes([]);
          } finally {
            setProvLoading(false);
          }
        };
      
        
      
        const fetchSubZones = async (selectedZone) => {
          setIsLoading(true);
          try {
            const response = await axios.get(`${BASE_URL}/zones/getareaszone?zone_id=${selectedZone}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearer}`,
          }, });
      
            // console.log(response);
            const subReg = response.data?.data;
            setTableData7(subReg);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setTableData7([]);
          } finally {
            setIsLoading(false);
          }
        };

    

        const fetchAllAreas = async (selectedZone) => {
          setAreaLoad(true);
          try {
            const response = await axios.get(`${BASE_URL1}/zones/getareaszone?zone_id=${selectedZone}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${TOKEN}`,
          }, });
      
            // console.log(response);
            const subReg1 = response.data?.data;
            const options1 = subReg1.map((item) => ({
              label: item.description,
              value: item.id,
            }));
            setAreas(options1);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setAreas([]);
          } finally {
            setAreaLoad(false);
          }
        };

        const fetchSubAreas = async (selectedArea) => {
          setIsLoading(true);
          try {
            const response = await axios.get(`${BASE_URL}/areas/getparishesarea?area_id=${selectedArea}`, 
            { headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearer}`,
          }, });
      
            // console.log(response);
            const subAreaa = response.data?.data;
            setTableData9(subAreaa);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            setTableData9([]);
          } finally {
            setIsLoading(false);
          }
        };
      
        
      
        useEffect(() => {
          if (bearer && selectedContinent) {
            fetchSubContinents(selectedContinent);
          }
        }, [bearer, selectedContinent]);

        useEffect(() => {
          if (bearer && selectedArea) {
            fetchSubAreas(selectedArea);
          }
        }, [bearer, selectedArea]);

        useEffect(() => {
          if (TOKEN && provinceID) {
            fetchAllZones(provinceID);
          }
        }, [TOKEN, provinceID]);

        useEffect(() => {
          if (TOKEN && selectedZone) {
            fetchAllAreas(selectedZone);
          }
        }, [TOKEN, selectedZone]);

        useEffect(() => {
          if (TOKEN && selectedArea) {
            fetchAllParishes(selectedArea);
          }
        }, [TOKEN, selectedArea]);
      
        useEffect(() => {
          if (bearer && selectedRegion) {
            fetchSubRegions(selectedRegion);
          }
        }, [bearer, selectedRegion]);
      
        useEffect(() => {
          if (bearer && selectedProvince) {
            fetchSubProvinces(selectedProvince);
          }
        }, [TOKEN, bearer, selectedProvince]);
      
        useEffect(() => {
          if (bearer && selectedZone) {
            fetchSubZones(selectedZone);
          }
        }, [bearer, selectedZone]);

        const handleZone = (selectedOption) => {
          setSelectedZone(selectedOption.value);
        };

        const handleArea = (selectedOption) => {
          setSelectedArea(selectedOption.value);
        };

        const handleParish = (selectedOption) => {
          setSelectedParish(selectedOption.value);
        };
      
        const createProvince = async () => {
          setLoaddd(true);
          try {
            const response = await axios.post(
              `${BASE_URL}/fixedassets/transfer`,
              {
                continent_id: selectedContinent,
                region_id: selectedRegion,
                area_id: selectedArea,
                province_id: selectedProvince,
                asset_id: selectedAssetId,
                zone_id: selectedZone,
                parish_id: selectedParish

               
              },
              { headers }
            );
            // console.log(response)
          //   fetchAssets();
            handleClose2();
            // return
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: response.data.message,
            });
            console.log(response.data);
      
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
            console.log(error);
          } finally {
            setLoaddd(false);
          }
        };

        const handleFixedAsset = () => {
          navigate('/home2')
        }




        function formatDate(dateString) {
          const date = new Date(dateString);
          const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
          return formattedDate;
        }
      
        function padZero(num) {
          return num < 10 ? `0${num}` : num;
        }


  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Fixed Asset Report</h3>
          </div>
        </div>

                <Tabs defaultActiveKey="approved" id="uncontrolled-tab-example"
                  className="mb-3 mt-3 complete-tabs"
                  variant="underline">
                    <Tab eventKey="approved" title="Approved Asset">
                      <div className={classes.topNavBars}>
                        <div className={classes.filterRow}>
                          {/* Left side: Inputs */}
                          <div className={classes.filterInputs}>
                          
                            <div className={classes.inlineField}>
                                {userTypes === "Regional Accountant" && ( 
                                  <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Provinces:</label>
                                    <Select
                                      onChange={handleProvinceChange}
                                      options={tableData45}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200, 
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14,
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />
                    
                                  </div>
                                )}
                                {userTypes === "Continental Accountant" && ( 
                                  <div style={{display: "flex", gap: 20}}>
                                  <div className={classes.inlineField}>
                                  <label className={classes.inlineLabel}>Region:</label>
                                  <Select
                                    onChange={handleRegionChange}
                                    options={tableData3}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      container: (provided) => ({
                                        ...provided,
                                        width: 200,
                                        fontSize: 14, 
                                      }),
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: "36px",
                                        fontSize: 14, 
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        fontSize: 14, 
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        fontSize: 14, 
                                        backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                        color: "#111827",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: "300px",
                                        maxWidth: "200px",
                                        overflowY: "auto",
                                        fontSize: 14, 
                                      }),
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    className={classes.inlineSelect}
                                  />
                  
                                </div>

                                <div className={classes.inlineField}>
                                  <label className={classes.inlineLabel}>Province:</label>
                                  <Select
                                    onChange={handleProvinceChange}
                                    options={tableData4}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      container: (provided) => ({
                                        ...provided,
                                        width: 200, // ✅ fixed width
                                        fontSize: 14, // applies to the wrapper
                                      }),
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: "36px",
                                        fontSize: 14, // ✅ font size inside control
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        fontSize: 14, // ✅ selected value text
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        fontSize: 14, // ✅ dropdown option text
                                        backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                        color: "#111827",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: "300px",
                                        maxWidth: "200px",
                                        overflowY: "auto",
                                        fontSize: 14, // ✅ font size in menu
                                      }),
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    className={classes.inlineSelect}
                                  />
                  
                                </div>
                                  </div>
                                )}
                                  <div style={{display: "flex", gap: 20}}>
                                    <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Zone:</label>
                                    <Select
                                      onChange={(selectedOption) => handleZone(selectedOption)}
                                      options={zones}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200,
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14, 
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />                  
                                    </div>
                                    <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Area:</label>
                                    <Select
                                      placeholder='Select Area'
                                      onChange={(selectedOption) => handleArea(selectedOption)}
                                      options={areas}                                    menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200,
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14, 
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />
                    
                                    </div>
                                    <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Parish:</label>
                                    <Select
                                      placeholder='Select Parish'
                                      onChange={(selectedOption) => handleParish(selectedOption)}
                                      options={parishes}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200,
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14, 
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />
                    
                                    </div>
                                    <button className={classes.loanBtn} onClick={handleProcess}> <img src={run} alt="run-report" /> Run Report </button>
                                  </div>
                            </div>
                          </div>

                          {/* Right side: 3 icons */}

                        </div>


                      </div>
                      {/* <div className={classes.marginKilode} /> */}
                      <div className={classes.tableContainer}>
                        <div className={classes.tableContainer}>
                          <div className={classes.headerActions}>
                            <div className={classes.actionsRight}>
                              <div className={classes.inputWrapper}>
                                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                                <input type="text" className={classes.searchBar} placeholder="Search sales" />
                              </div>
                              <div className={classes.selectWrapper}>
                                <select className={classes.dropdown}>
                                  <option value="">All Status</option>
                                  <option value="Paid">Paid</option>
                                  <option value="Pending">Pending</option>
                                  <option value="Overdue">Overdue</option>
                                  <option value="Draft">Draft</option>
                                </select>
                                <span className={classes.dropdownArrow}>▼</span>
                              </div>

                              <div className={classes.inputWrapper}>
                                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                                <img src={filter} alt="Filter" className={classes.inputIcon} />
                              </div>
                            </div>
                            <div className={classes.actionsLeft}>
                              {/* <button className={classes.btnss} onClick={handleGeneratePaymentInstruction} disabled={selectedRows.length === 0}> + Proceed</button> */}
                              {Array.isArray(tableData) && tableData.length > 0 && (
                                <button className={classes.btnss} onClick={() => navigate('/fixed_asset/print_report', { state: { tableData: tableData, allReport:allReport } })}>Print Report</button>
                              )}
                            </div>
                          </div>

                          <div className={classes.invoicecont}>
                            <table className={classes.invoiceTable}>
                              <table className={classes.invoiceTable}>
                                <thead style={{ whiteSpace: "nowrap" }}>
                                  <tr>
                                    <th>S/N</th>
                                    <th>Identification Number</th>
                                    <th>Asset Name</th>
                                    <th>Category</th>
                                    <th>Quantity</th>
                                    <th>Parish Name</th>
                                    <th>Province Name</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {(assetLoading || processLoading)
                                    ? Array(5)
                                      .fill()
                                      .map((_, idx) => (
                                        <tr key={idx}>
                                          {Array(8)
                                            .fill()
                                            .map((_, i) => (
                                              <td key={i}>
                                                <Skeleton height={20} style={{ marginBottom: 10 }} />
                                              </td>
                                            ))}
                                        </tr>
                                      ))
                                    : tableData.length === 0 ? (
                                      <tr>
                                        <td colSpan={10} style={{ textAlign: "center" }}>
                                          No Data found.
                                        </td>
                                      </tr>
                                    ) : (
                                      tableData.map((item, index) => (
                                        <tr key={item.id}>
                                          <td>{index + 1}</td>
                                          <td>{item?.identification_number}</td>
                                          <td>{item?.description}</td>
                                          <td>{item?.asset_category?.description}</td>
                                          <td>{item?.quantity}</td>
                                          <td>{item?.parish?.description}</td>
                                          <td>{item?.parish?.description}</td>
                                          <td className={classes.actions}>
                                            <Pen size={16} className={classes.editIcon} 
                                            onClick={() => handleEyeClicks(item.id)} 
                                            />
                                            <Trash2 size={16} className={classes.deleteIcon} />
                                            {/* <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                                              style={{ cursor: "pointer" }} /> */}
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                </tbody>
                              </table>
                            </table>
                            <div className={classes.paginationContainer}>
                              <div className={classes.paginationControls}>
                                <button                   
                                  onClick={handlePrevPage}
                                  disabled={currentPage === 1}
                                >Previous</button>
                                {[...Array(totalPages)].map((_, page) => {
                                    // Show only 5 pages or less if available
                                    if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                                      return(
                                  <button className={classes.active}  key={page + 1}
                                  style={{
                                    color: page + 1 === currentPage ? '#ffffff' : '#000',
                                    backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                                    cursor: "pointer"
                                  }}
                                  onClick={() => setCurrentPage(page + 1)}
                                > {page + 1}
                                </button>
                                      );
                                    }
                                    return null;
                                  })}
                                <button
                                  onClick={handleNextPage}
                                  disabled={currentPage === totalPages}
                                >Next
                                </button>
                                <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
                              </div>
                            </div>
                          </div>                  
                        </div>
                      </div>
                      
                    </Tab>
                    <Tab eventKey="pending" title="Pending Asset">
                      <div className={classes.topNavBars}>
                        <div className={classes.filterRow}>
                          {/* Left side: Inputs */}
                          <div className={classes.filterInputs}>
                          
                            <div className={classes.inlineField}>
                                {userTypes === "Regional Accountant" && ( 
                                  <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Provinces:</label>
                                    <Select
                                      onChange={handleProvinceChange}
                                      options={tableData45}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200, 
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14,
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />
                    
                                  </div>
                                )}
                                {userTypes === "Continental Accountant" && ( 
                                  <div style={{display: "flex", gap: 20}}>
                                  <div className={classes.inlineField}>
                                  <label className={classes.inlineLabel}>Region:</label>
                                  <Select
                                    onChange={handleRegionChange}
                                    options={tableData3}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      container: (provided) => ({
                                        ...provided,
                                        width: 200,
                                        fontSize: 14, 
                                      }),
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: "36px",
                                        fontSize: 14, 
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        fontSize: 14, 
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        fontSize: 14, 
                                        backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                        color: "#111827",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: "300px",
                                        maxWidth: "200px",
                                        overflowY: "auto",
                                        fontSize: 14, 
                                      }),
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    className={classes.inlineSelect}
                                  />
                  
                                </div>

                                <div className={classes.inlineField}>
                                  <label className={classes.inlineLabel}>Province:</label>
                                  <Select
                                    onChange={handleProvinceChange}
                                    options={tableData4}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      container: (provided) => ({
                                        ...provided,
                                        width: 200, // ✅ fixed width
                                        fontSize: 14, // applies to the wrapper
                                      }),
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: "36px",
                                        fontSize: 14, // ✅ font size inside control
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        fontSize: 14, // ✅ selected value text
                                      }),
                                      option: (provided, state) => ({
                                        ...provided,
                                        fontSize: 14, // ✅ dropdown option text
                                        backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                        color: "#111827",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: "300px",
                                        maxWidth: "200px",
                                        overflowY: "auto",
                                        fontSize: 14, // ✅ font size in menu
                                      }),
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    className={classes.inlineSelect}
                                  />
                  
                                </div>
                                  </div>
                                )}
                                  <div style={{display: "flex", gap: 20}}>
                                    <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Zone:</label>
                                    <Select
                                      onChange={(selectedOption) => handleZone(selectedOption)}
                                      options={zones}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200,
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14, 
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />                  
                                    </div>
                                    <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Area:</label>
                                    <Select
                                      placeholder='Select Area'
                                      onChange={(selectedOption) => handleArea(selectedOption)}
                                      options={areas}                                    menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200,
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14, 
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />
                    
                                    </div>
                                    <div className={classes.inlineField}>
                                    <label className={classes.inlineLabel}>Parish:</label>
                                    <Select
                                      placeholder='Select Parish'
                                      onChange={(selectedOption) => handleParish(selectedOption)}
                                      options={parishes}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          width: 200,
                                          fontSize: 14, 
                                        }),
                                        control: (provided) => ({
                                          ...provided,
                                          minHeight: "36px",
                                          fontSize: 14, 
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          fontSize: 14, 
                                        }),
                                        option: (provided, state) => ({
                                          ...provided,
                                          fontSize: 14, 
                                          backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                          color: "#111827",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: "300px",
                                          maxWidth: "200px",
                                          overflowY: "auto",
                                          fontSize: 14, 
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}
                                      className={classes.inlineSelect}
                                    />
                    
                                    </div>
                                    <button className={classes.loanBtn} onClick={handleProcess}> <img src={run} alt="run-report" /> Run Report </button>
                                  </div>
                            </div>
                          </div>

                          {/* Right side: 3 icons */}

                        </div>


                      </div>
                      {/* <div className={classes.marginKilode} /> */}
                      <div className={classes.tableContainer}>
                        <div className={classes.tableContainer}>
                          <div className={classes.headerActions}>
                            <div className={classes.actionsRight}>
                              <div className={classes.inputWrapper}>
                                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                                <input type="text" className={classes.searchBar} placeholder="Search sales" />
                              </div>
                              <div className={classes.selectWrapper}>
                                <select className={classes.dropdown}>
                                  <option value="">All Status</option>
                                  <option value="Paid">Paid</option>
                                  <option value="Pending">Pending</option>
                                  <option value="Overdue">Overdue</option>
                                  <option value="Draft">Draft</option>
                                </select>
                                <span className={classes.dropdownArrow}>▼</span>
                              </div>

                              <div className={classes.inputWrapper}>
                                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                                <img src={filter} alt="Filter" className={classes.inputIcon} />
                              </div>
                            </div>
                            <div className={classes.actionsLeft}>
                              {/* <button className={classes.btnss} onClick={handleGeneratePaymentInstruction} disabled={selectedRows.length === 0}> + Proceed</button> */}
                              {Array.isArray(tableData) && tableData.length > 0 && (
                                <button className={classes.btnss} onClick={() => navigate('/fixed_asset/print_report', { state: { tableData: tableData, allReport:allReport } })}>Print Report</button>
                              )}
                            </div>
                          </div>

                          <div className={classes.invoicecont}>
                            <table className={classes.invoiceTable}>
                              <table className={classes.invoiceTable}>
                                <thead style={{ whiteSpace: "nowrap" }}>
                                  <tr>
                                    <th>S/N</th>
                                    <th>Identification Number</th>
                                    <th>Asset Name</th>
                                    <th>Category</th>
                                    <th>Quantity</th>
                                    <th>Parish Name</th>
                                    <th>Province Name</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {(assetLoading || processLoading)
                                    ? Array(5)
                                      .fill()
                                      .map((_, idx) => (
                                        <tr key={idx}>
                                          {Array(8)
                                            .fill()
                                            .map((_, i) => (
                                              <td key={i}>
                                                <Skeleton height={20} style={{ marginBottom: 10 }} />
                                              </td>
                                            ))}
                                        </tr>
                                      ))
                                    : tableDatas.length === 0 ? (
                                      <tr>
                                        <td colSpan={10} style={{ textAlign: "center" }}>
                                          No Data found.
                                        </td>
                                      </tr>
                                    ) : (
                                      tableDatas.map((item, index) => (
                                        <tr key={item.id}>
                                          <td>{index + 1}</td>
                                          <td>{item?.identification_number}</td>
                                          <td>{item?.description}</td>
                                          <td>{item?.asset_category?.description}</td>
                                          <td>{item?.quantity}</td>
                                          <td>{item?.parish?.description}</td>
                                          <td>{item?.parish?.description}</td>
                                          <td className={classes.actions}>
                                            <Pen size={16} className={classes.editIcon} 
                                            onClick={() => handleEyeClicks(item.id)} 
                                            />
                                            <Trash2 size={16} className={classes.deleteIcon} />
                                            {/* <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                                              style={{ cursor: "pointer" }} /> */}
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                </tbody>
                              </table>
                            </table>
                            <div className={classes.paginationContainer}>
                              <div className={classes.paginationControls}>
                                <button                   
                                  onClick={handlePrevPage}
                                  disabled={currentPage === 1}
                                >Previous</button>
                                {[...Array(totalPages)].map((_, page) => {
                                    // Show only 5 pages or less if available
                                    if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                                      return(
                                  <button className={classes.active}  key={page + 1}
                                  style={{
                                    color: page + 1 === currentPage ? '#ffffff' : '#000',
                                    backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                                    cursor: "pointer"
                                  }}
                                  onClick={() => setCurrentPage(page + 1)}
                                > {page + 1}
                                </button>
                                      );
                                    }
                                    return null;
                                  })}
                                <button
                                  onClick={handleNextPage}
                                  disabled={currentPage === totalPages}
                                >Next
                                </button>
                                <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
                              </div>
                            </div>
                          </div>                  
                        </div>
                      </div>
                    </Tab>
                </Tabs>

      

              </div>
       




          {savingsLoading && (
            <div className={classes.overlay}>
              <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
            </div>
          )}

        </div>
        )
}
        export default FixedAssetReport;
